import apiSvc from '../services/apiSvc';
import validSvc from '../validSvc';

// endpoints
const GET_VERITY_TERMS = 'user/verityterms';
const GET_CLIENT_TERMS = 'user/termsget';
const UPDATE_AGREE = 'user/termsagree';

// DEFINITION
const termsRepo = {
    get: termsGet,
    agree: termsAgree,
};

async function termsGet(isVerity: boolean): Promise<object> {
    const purl = isVerity ? GET_VERITY_TERMS : GET_CLIENT_TERMS;
    return await apiSvc.getEntity(purl);
}

async function termsAgree(id: string): Promise<any> {
    if (!validSvc.isText(id)) {
        throw new Error('termsAgree, id required');
    }
    const postData = {
        Entity: {
            TermsId: id,
        },
    };
    return apiSvc.post(UPDATE_AGREE, postData);
}

export default termsRepo;
